import React from 'react';
import { useIntl } from 'react-intl';
import styles from './tutorialBody.mod.scss';
import TutorialModal from '@sections/creabots/components/tutorialModal';
import clsx from 'clsx';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import TutorialProgressV2 from '@sections/creabots/components/tutorialProgressV2'
import { CODE_CHECK_TYPE } from '@sections/creabots/types/kits'

const TutorialBody = (props) => {
  const intl = useIntl();
  const steps = props.steps || [];
  const currentStep = props.currentStep || 0;
  const currentStepId = props.currentStepId || 0;
  const totalStepId = props.totalStepId || 0;
  const onNextStep = (props.onNextStep) ? props.onNextStep : null;
  const onPrevStep = (props.onPrevStep) ? props.onPrevStep : null;
  const backToHome = (props.backToHome) ? props.backToHome : null;

  const stepObj = steps[currentStep] || null;
  const iaStep = Boolean(stepObj?.stepId) || false;
  const currentStepObj = steps.find((step) => step.stepId === currentStepId) || null;
  const CurrentStepComponent = (stepObj && stepObj.component) ? stepObj.component : ((currentStepObj && currentStepObj.component) ? currentStepObj.component : null);

  return (
    <div className={styles.tutorialBody}>
      {(currentStepObj || stepObj) && steps[currentStep] ? (
        <TutorialModal showBackdrop={(steps[currentStep].completionCodeCheck === CODE_CHECK_TYPE.BUILT)} init={currentStepId} open={(currentStepId + 1)} type={stepObj?.modal || currentStepObj?.modal || 'normal'}>
          <>
            {(CurrentStepComponent) ? (
              <CurrentStepComponent
                currentStep={currentStepId}
                totalSteps={totalStepId}
                onNextStep={onNextStep}
                onPrevStep={onPrevStep}
                videoUrl={stepObj?.videoUrl || ''}
                images={stepObj?.images}
              />
            ) : (
              <>
                <div className={styles.titleContainer}>
                  <div className={styles.title}><AssignmentOutlinedIcon /> {intl.formatMessage({ id: stepObj?.title || currentStepObj?.title || 'creabots.tutorialTitle' })}</div>
                </div>
                <div className={styles.instructionsContainer}>
                  {(stepObj?.description || currentStepObj?.description) ? (
                    <div className={styles.description} dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: stepObj?.description || currentStepObj?.description }) }} />
                    // <div>{intl.formatMessage({ id: stepObj?.description || currentStepObj?.description })}</div>
                  ) : ('')}
                  {(stepObj?.image || currentStepObj?.image) ? (
                    <img src={stepObj?.image || currentStepObj?.image} />
                  ) : ('')}
                  {(stepObj?.video || currentStepObj?.video) ? (
                    <video
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        maxHeight: '80vh'
                      }}
                      src={stepObj?.video || currentStepObj?.video}
                      autoPlay
                      muted
                      onPlay={(e) => e.target.controls = false}
                    />
                  ) : ('')}
                </div>
                <div className={styles.progressContainer}>
                  {steps.length > currentStep + 1 && (
                    <TutorialProgressV2 iaStep={iaStep} currentStep={currentStepId + 1} totalStep={totalStepId} onNextStep={onNextStep} onPrevStep={onPrevStep} />
                  )}
                </div>
              </>
            )}
          </>
        </TutorialModal>
      ) : ('')}
    </div>
  );
};


export default TutorialBody;